export default __webpack_public_path__ + "50f6ca1858571cb01dd372efcfea3238.svg";